<template>
  <form @submit.prevent="onSearch">
    <div class="searchBar">
      <input type="text" :placeholder="$t('message.searchText') + '...'" v-model="searchTerm" />
      <mu-flat-button label="Search" @click="onSearch" />
    </div>
    <input type="submit" style="display: none;" />
  </form>
</template>
<script>
  export default {
    name: 'life-search-bar',
    props: {
      value: {
        type: String,
        required: false,
      }
    },
    data() {
      return {
        searchTerm: "",
      }
    },
    methods: {
      onSearch() {
        let self = this;
        if(self.searchTerm) {
          self.$router.push({
            name: 'LifeStyleSearch',
            params: {
              search: self.searchTerm
            }
          });
        } else {
          self.$toastr.error('Please enter a search value');
        }
      }
    },
    mounted() {
      let self = this;
      if( self.value ) {
        self.searchTerm = self.value;
      }
    }
  }
</script>
<style lang="less">
  @import "../../../styles/theme.less";
  .searchBar {
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    input {
      width: 100%;
      border: 1px solid #ccc;
      outline: 0;
      color: #4A4A4A;
      font-size: 14px;
      border-radius: 8px;
      box-shadow: none;
      padding: 8px 12px;
      margin-right: 24px;
      font-family: 'Poppins', sans-serif;
      &:focus {
        border-color: #3898ec;
      }
    }
    .mu-flat-button {
      background-color: rgba(1,118,208,.1);
      border-radius: 8px;
      min-width: 145px;
      height: 45px;
      .mu-flat-button-label {
        color: #0176d0;
        font-size: 1rem;
        font-family: 'Poppins', sans-serif;
        font-weight: 500;
        text-transform: none;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// LifeSearchBar.vue?091da86c